import { AxiosError } from 'axios'

export function errorResponseInterceptor(error: AxiosError) {
  console.error({ error })
  throw error?.response
}
